import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "asset-modbus-param-set",
  class: "assets-table-container"
}
const _hoisted_2 = { class: "modbus-param-set-card" }
const _hoisted_3 = { class: "modbus-param-set-card__header" }
const _hoisted_4 = { class: "modbus-param-set-card__title" }
const _hoisted_5 = { class: "modbus-param-form" }
const _hoisted_6 = { class: "modbus-param-form__group" }
const _hoisted_7 = {
  class: "modbus-param-form__label",
  for: "modbus-asset-select"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  value: null,
  disabled: ""
}
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 0,
  class: "modbus-param-form__meta"
}
const _hoisted_12 = { class: "modbus-meta-chip" }
const _hoisted_13 = { class: "modbus-meta-chip modbus-meta-chip--muted" }
const _hoisted_14 = { class: "modbus-param-form__group" }
const _hoisted_15 = {
  class: "modbus-param-form__label",
  for: "modbus-param-select"
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  value: null,
  disabled: ""
}
const _hoisted_18 = ["label"]
const _hoisted_19 = ["value"]
const _hoisted_20 = ["label"]
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 0,
  class: "modbus-param-form__hint"
}
const _hoisted_23 = {
  key: 0,
  class: "dkn-readonly-badge"
}
const _hoisted_24 = {
  key: 1,
  class: "modbus-param-form__hint"
}
const _hoisted_25 = { class: "modbus-param-form__group" }
const _hoisted_26 = { class: "modbus-param-form__label" }
const _hoisted_27 = {
  key: 0,
  class: "modbus-param-form__input-row"
}
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 0,
  class: "spinner-border spinner-border-sm modbus-param-submit-btn__spinner",
  role: "status"
}
const _hoisted_30 = {
  key: 1,
  class: "bi bi-power modbus-param-submit-btn__icon"
}
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 0,
  class: "spinner-border spinner-border-sm modbus-param-submit-btn__spinner",
  role: "status"
}
const _hoisted_33 = {
  key: 1,
  class: "bi bi-stop-circle modbus-param-submit-btn__icon"
}
const _hoisted_34 = {
  key: 1,
  class: "modbus-param-form__input-row"
}
const _hoisted_35 = ["min", "max", "step", "placeholder", "disabled"]
const _hoisted_36 = ["disabled"]
const _hoisted_37 = {
  key: 0,
  class: "spinner-border spinner-border-sm modbus-param-submit-btn__spinner",
  role: "status"
}
const _hoisted_38 = {
  key: 1,
  class: "bi bi-send-fill modbus-param-submit-btn__icon"
}
const _hoisted_39 = {
  key: 2,
  class: "modbus-param-form__input-row"
}
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 0,
  class: "spinner-border spinner-border-sm modbus-param-submit-btn__spinner",
  role: "status"
}
const _hoisted_42 = {
  key: 1,
  class: "bi bi-play-circle modbus-param-submit-btn__icon"
}
const _hoisted_43 = { class: "modbus-param-form__hint" }
const _hoisted_44 = { class: "modbus-param-form__hint" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "modbus-param-form__hint" }
const _hoisted_47 = {
  key: 0,
  class: "modbus-param-form__hint"
}
const _hoisted_48 = {
  key: 1,
  class: "modbus-param-form__hint"
}
const _hoisted_49 = {
  key: 2,
  class: "modbus-readout"
}
const _hoisted_50 = { class: "modbus-readout__row" }
const _hoisted_51 = {
  key: 0,
  class: "modbus-readout__value"
}
const _hoisted_52 = {
  key: 1,
  class: "modbus-readout__value modbus-readout__value--empty"
}
const _hoisted_53 = {
  key: 2,
  class: "modbus-readout__timestamp"
}
const _hoisted_54 = { class: "modbus-readout__param" }
const _hoisted_55 = {
  key: 5,
  class: "modbus-param-form__input-row"
}
const _hoisted_56 = ["placeholder", "disabled"]
const _hoisted_57 = ["disabled"]
const _hoisted_58 = {
  key: 0,
  class: "spinner-border spinner-border-sm modbus-param-submit-btn__spinner",
  role: "status"
}
const _hoisted_59 = {
  key: 1,
  class: "bi bi-send-fill modbus-param-submit-btn__icon"
}
const _hoisted_60 = { class: "modbus-verify-card__inner" }
const _hoisted_61 = {
  key: 0,
  class: "spinner-border spinner-border-sm modbus-verify-card__spinner",
  role: "status"
}
const _hoisted_62 = { class: "modbus-verify-card__body" }
const _hoisted_63 = { class: "modbus-verify-card__message" }
const _hoisted_64 = {
  key: 0,
  class: "modbus-verify-card__raw"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[13] || (_cache[13] = _createElementVNode("i", { class: "bi bi-sliders modbus-param-set-card__icon" }, null, -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('components.assetModbusParamSet.title')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('components.assetModbusParamSet.assetSerial')), 1),
          _withDirectives(_createElementVNode("select", {
            id: "modbus-asset-select",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedSerialNumber) = $event)),
            class: "form-select modbus-param-form__select",
            disabled: _ctx.loadingAssets,
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onAssetChange && _ctx.onAssetChange(...args)))
          }, [
            _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.loadingAssets ? _ctx.$t('components.assetModbusParamSet.loading') : _ctx.$t('components.assetModbusParamSet.selectAsset')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assets, (asset) => {
              return (_openBlock(), _createElementBlock("option", {
                key: asset.serial_number,
                value: asset.serial_number
              }, _toDisplayString(asset.name ? `${asset.serial_number} (${asset.name})` : asset.serial_number), 9, _hoisted_10))
            }), 128))
          ], 40, _hoisted_8), [
            [_vModelSelect, _ctx.selectedSerialNumber]
          ]),
          _createVNode(_Transition, { name: "modbus-slide-down" }, {
            default: _withCtx(() => [
              (_ctx.selectedAsset)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, [
                      _cache[14] || (_cache[14] = _createElementVNode("i", { class: "bi bi-tag-fill" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.selectedAsset.name), 1)
                    ]),
                    _createElementVNode("span", _hoisted_13, [
                      _cache[15] || (_cache[15] = _createElementVNode("i", { class: "bi bi-cpu" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.selectedAsset.imei), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('components.assetModbusParamSet.parameter')), 1),
          _withDirectives(_createElementVNode("select", {
            id: "modbus-param-select",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedParamName) = $event)),
            class: "form-select modbus-param-form__select",
            disabled: _ctx.loadingParams || _ctx.loadingDkn || !_ctx.selectedSerialNumber,
            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onParamChange && _ctx.onParamChange(...args)))
          }, [
            _createElementVNode("option", _hoisted_17, _toDisplayString((_ctx.loadingParams || _ctx.loadingDkn) ? _ctx.$t('components.assetModbusParamSet.loading') : _ctx.$t('components.assetModbusParamSet.selectParameter')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedDknActions, (group) => {
              return (_openBlock(), _createElementBlock("optgroup", {
                key: 'dkn_' + group.key,
                label: '★ ' + group.label
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.actions, (a) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: a.canonical_key,
                    value: _ctx.DKN_PREFIX + a.canonical_key
                  }, _toDisplayString(a.action_type === 'readonly' ? `○ ${a.label || a.canonical_key}` : `● ${a.label || a.canonical_key}`), 9, _hoisted_19))
                }), 128))
              ], 8, _hoisted_18))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedParams, (group) => {
              return (_openBlock(), _createElementBlock("optgroup", {
                key: group.label,
                label: group.label
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.params, (param) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: param.id,
                    value: param.param_name
                  }, _toDisplayString(param.description || param.param_name), 9, _hoisted_21))
                }), 128))
              ], 8, _hoisted_20))
            }), 128))
          ], 40, _hoisted_16), [
            [_vModelSelect, _ctx.selectedParamName]
          ]),
          _createVNode(_Transition, { name: "modbus-slide-down" }, {
            default: _withCtx(() => [
              (_ctx.selectedDknAction)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _cache[17] || (_cache[17] = _createElementVNode("i", { class: "bi bi-code-slash" }, null, -1)),
                    _createElementVNode("code", null, _toDisplayString(_ctx.selectedDknAction.canonical_key), 1),
                    (_ctx.selectedDknAction.action_type === 'readonly')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                          _cache[16] || (_cache[16] = _createElementVNode("i", { class: "bi bi-eye" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetDknControlPanel.readOnlyBadge')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_ctx.selectedParam)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _cache[18] || (_cache[18] = _createElementVNode("i", { class: "bi bi-code-slash" }, null, -1)),
                      _createElementVNode("code", null, _toDisplayString(_ctx.selectedParam.param_name), 1)
                    ]))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('components.assetModbusParamSet.value')), 1),
          (_ctx.selectedDknAction?.action_type === 'toggle')
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("button", {
                  class: "modbus-param-submit-btn dkn-btn--on",
                  disabled: _ctx.sending,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submitDkn(1)))
                }, [
                  (_ctx.sending && _ctx.dknPendingValue === 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_29))
                    : (_openBlock(), _createElementBlock("i", _hoisted_30)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetDknControlPanel.actions.on')), 1)
                ], 8, _hoisted_28),
                _createElementVNode("button", {
                  class: "modbus-param-submit-btn dkn-btn--off",
                  disabled: _ctx.sending,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submitDkn(0)))
                }, [
                  (_ctx.sending && _ctx.dknPendingValue === 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_32))
                    : (_openBlock(), _createElementBlock("i", _hoisted_33)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetDknControlPanel.actions.off')), 1)
                ], 8, _hoisted_31)
              ]))
            : (_ctx.selectedDknAction?.action_type === 'setpoint')
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dknNumericValue) = $event)),
                    type: "number",
                    class: "form-control modbus-param-form__input",
                    min: _ctx.selectedDknAction.value_min ?? undefined,
                    max: _ctx.selectedDknAction.value_max ?? undefined,
                    step: _ctx.selectedDknAction.value_step ?? 1,
                    placeholder: _ctx.selectedDknAction.unit ? `${_ctx.$t('components.assetDknControlPanel.valuePlaceholder')} (${_ctx.selectedDknAction.unit})` : _ctx.$t('components.assetDknControlPanel.valuePlaceholder'),
                    disabled: _ctx.sending,
                    onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.submitDkn(_ctx.dknNumericValue)), ["enter"]))
                  }, null, 40, _hoisted_35), [
                    [
                      _vModelText,
                      _ctx.dknNumericValue,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("button", {
                    class: "modbus-param-submit-btn",
                    disabled: _ctx.sending || _ctx.dknNumericValue === null,
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.submitDkn(_ctx.dknNumericValue)))
                  }, [
                    (_ctx.sending)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_37))
                      : (_openBlock(), _createElementBlock("i", _hoisted_38)),
                    _createTextVNode(" " + _toDisplayString(_ctx.sending ? _ctx.$t('components.assetDknControlPanel.sending') : _ctx.$t('components.assetDknControlPanel.actions.set')), 1)
                  ], 8, _hoisted_36)
                ]))
              : (_ctx.selectedDknAction?.action_type === 'command')
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("button", {
                      class: "modbus-param-submit-btn",
                      disabled: _ctx.sending,
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.submitDkn(1)))
                    }, [
                      (_ctx.sending)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_41))
                        : (_openBlock(), _createElementBlock("i", _hoisted_42)),
                      _createTextVNode(" " + _toDisplayString(_ctx.sending ? _ctx.$t('components.assetDknControlPanel.sending') : _ctx.$t('components.assetDknControlPanel.actions.run')), 1)
                    ], 8, _hoisted_40)
                  ]))
                : (_ctx.selectedDknAction?.action_type === 'readonly')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createElementVNode("div", _hoisted_43, [
                        _cache[19] || (_cache[19] = _createElementVNode("i", { class: "bi bi-eye" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetDknControlPanel.readOnly')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _cache[20] || (_cache[20] = _createElementVNode("i", { class: "bi bi-activity" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetDknControlPanel.latestValue')) + ": ", 1),
                        _createElementVNode("code", null, _toDisplayString(_ctx.selectedDknAction.latest_value?.param_name || _ctx.selectedDknAction.read_param), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.selectedDknAction.latest_value?.value ?? _ctx.$t('components.assetDknControlPanel.noLatestValue')), 1),
                        (_ctx.selectedDknAction.latest_value?.created_at)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_ctx.$t('components.assetDknControlPanel.latestRecordAt')) + ": " + _toDisplayString(_ctx.formatLatestRecordDate(_ctx.selectedDknAction.latest_value.created_at)), 1))
                          : _createCommentVNode("", true)
                      ])
                    ], 64))
                  : (_ctx.isDknUart && _ctx.selectedParam)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        _createElementVNode("div", _hoisted_46, [
                          _cache[21] || (_cache[21] = _createElementVNode("i", { class: "bi bi-eye" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetDknControlPanel.readOnly')), 1)
                        ]),
                        (_ctx.selectedDknUartGroup)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                              _cache[22] || (_cache[22] = _createElementVNode("i", { class: "bi bi-collection" }, null, -1)),
                              _createElementVNode("code", null, _toDisplayString(_ctx.selectedDknUartGroup.code), 1),
                              _createElementVNode("span", null, _toDisplayString(_ctx.selectedDknUartGroup.label), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.loadingDknUartLatest)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                              _cache[23] || (_cache[23] = _createElementVNode("span", {
                                class: "spinner-border spinner-border-sm",
                                role: "status"
                              }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetModbusParamSet.loading')), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, [
                                (_ctx.dknUartLatestValue?.value !== undefined && _ctx.dknUartLatestValue?.value !== null)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_ctx.dknUartLatestValue.value), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_ctx.$t('components.assetDknControlPanel.noLatestValue')), 1)),
                                (_ctx.dknUartLatestValue?.created_at)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_53, [
                                      _cache[24] || (_cache[24] = _createElementVNode("i", { class: "bi bi-clock" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.formatLatestRecordDate(_ctx.dknUartLatestValue.created_at)), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_54, [
                                _cache[25] || (_cache[25] = _createElementVNode("i", { class: "bi bi-tag" }, null, -1)),
                                _createElementVNode("code", null, _toDisplayString(_ctx.dknUartLatestValue?.param_name || _ctx.selectedParam.param_name), 1)
                              ])
                            ]))
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        _withDirectives(_createElementVNode("input", {
                          id: "modbus-param-value",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.paramValue) = $event)),
                          type: "text",
                          class: "form-control modbus-param-form__input",
                          placeholder: _ctx.$t('components.assetModbusParamSet.valuePlaceholder'),
                          disabled: !_ctx.selectedParamName || _ctx.sending,
                          onKeyup: _cache[11] || (_cache[11] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitParam && _ctx.submitParam(...args)), ["enter"]))
                        }, null, 40, _hoisted_56), [
                          [_vModelText, _ctx.paramValue]
                        ]),
                        _createElementVNode("button", {
                          class: "modbus-param-submit-btn",
                          disabled: !_ctx.canSubmit || _ctx.sending,
                          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.submitParam && _ctx.submitParam(...args)))
                        }, [
                          (_ctx.sending)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_58))
                            : (_openBlock(), _createElementBlock("i", _hoisted_59)),
                          _createTextVNode(" " + _toDisplayString(_ctx.sending ? _ctx.$t('components.assetModbusParamSet.sending') : _ctx.$t('components.assetModbusParamSet.set')), 1)
                        ], 8, _hoisted_57)
                      ]))
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "modbus-status-fade" }, {
      default: _withCtx(() => [
        (_ctx.verifyStage)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['modbus-verify-card', `modbus-verify-card--${_ctx.statusVariant}`])
            }, [
              _createElementVNode("div", _hoisted_60, [
                (_ctx.isStatusLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_61))
                  : (_openBlock(), _createElementBlock("i", {
                      key: 1,
                      class: _normalizeClass(['bi', _ctx.statusIcon, 'modbus-verify-card__icon'])
                    }, null, 2)),
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("p", _hoisted_63, _toDisplayString(_ctx.statusMessage), 1),
                  (_ctx.verifyReadResult && _ctx.verifyStage === 'success')
                    ? (_openBlock(), _createElementBlock("code", _hoisted_64, _toDisplayString(_ctx.verifyReadResult), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}